import SuperAdminLayout from "../../components/layouts/SuperAdminLayout";
import ProtectedRoute from "../utils/ProtectedRoute";
import RequireRole from "../utils/RequireRole";
import SuperAdminDashboard from "../../features/superadmin/SuperAdminDashboard";
import RegisterUserForm from "../../features/admin/RegisterUserForm";
import UserList from "../../features/admin/UserList";
import { DeliveryBoyList, AddDeliveryBoy, EditDeliveryBoy } from "../../features/delivery-boys/pages";

export const SuperAdmin = [
  {
    path: "/superadmin/",
    element: (
      <ProtectedRoute>
        <RequireRole allowedRoles={["superadmin"]}>
          <SuperAdminLayout>
            <SuperAdminDashboard />
          </SuperAdminLayout>
        </RequireRole>
      </ProtectedRoute>
    ),
  },
  {
    path: "/superadmin/usersregister",
    element: (
      <ProtectedRoute>
        <RequireRole allowedRoles={["superadmin"]}>
          <SuperAdminLayout>
            <RegisterUserForm />
          </SuperAdminLayout>
        </RequireRole>
      </ProtectedRoute>
    ),
  },
  {
    path: "/superadmin/userslist",
    element: (
      <ProtectedRoute>
        <RequireRole allowedRoles={["superadmin"]}>
          <SuperAdminLayout>
            <UserList />
          </SuperAdminLayout>
        </RequireRole>
      </ProtectedRoute>
    ),
  },

  // Delivery Boys Management
  {
    path: "/superadmin/delivery-boys/list",
    element: (
      <ProtectedRoute>
        <RequireRole allowedRoles={["superadmin"]}>
          <SuperAdminLayout>
            <DeliveryBoyList />
          </SuperAdminLayout>
        </RequireRole>
      </ProtectedRoute>
    ),
  },

  // Add Delivery Boy
  {
    path: "/superadmin/delivery-boys/add",
    element: (
      <ProtectedRoute>
        <RequireRole allowedRoles={["superadmin"]}>
          <SuperAdminLayout>
            <AddDeliveryBoy />
          </SuperAdminLayout>
        </RequireRole>
      </ProtectedRoute>
    ),
  },

  // Edit Delivery Boy
  {
    path: "/superadmin/delivery-boys/edit/:id",
    element: (
      <ProtectedRoute>
        <RequireRole allowedRoles={["superadmin"]}>
          <SuperAdminLayout>
            <EditDeliveryBoy />
          </SuperAdminLayout>
        </RequireRole>
      </ProtectedRoute>
    ),
  },
];
